import Data from '../../data/main/config/setup/material/materials'

const state = {
  materialType: Data.materials.pvc600.type,
  materialTypeCode: Data.materials.pvc600.code,
  materialColor: {
    color: '',
    hex: ''
  },
  materialColorImg: {
    schnittkante: '',
    saum: '',
    hohlsaum: '',
    keder: '',
    hohlschnitt: ''
  },
  materialColorCode: '',
  colorSelected: undefined,
  materialTabIndex: 0,
  materialSelected: 1
}

const mutations = {
  'SET_MATERIAL_TYPE' (state, material) {
    state.materialType = material.type
    state.materialTypeCode = material.code
  },
  'SET_MATERIAL_COLOR' (state, matColor) {
    state.materialColor.color = matColor.color
    state.materialColor.hex = matColor.hex
    state.materialColorCode = matColor.code
    state.materialColorImg = matColor.img
  },
  'SET_MATERIAL_TABINDEX' (state, value) {
    state.materialTabIndex = value
  },
  'CLEAR_MATERIAL_COLOR' (state) {
    state.materialColor.color = ''
    state.materialColor.hex = ''
    state.materialColorImg = {
      schnittkante: '',
      saum: '',
      hohlsaum: '',
      keder: '',
      hohlschnitt: ''
    }
    state.materialColorCode = ''
  },
  'SELECT_MATERIAL' (state, index) {
    state.materialSelected = index
  },
  'SELECT_COLOR' (state, index) {
    state.colorSelected = index
  },
  'CLEAR_MATERIAL' (state) {
    state.materialType = Data.materials.pvc600.type
    state.materialTypeCode = Data.materials.pvc600.code
    state.materialColor = {
      color: '',
      hex: ''
    }
    state.materialColorImg = {
      schnittkante: '',
      saum: '',
      hohlsaum: '',
      keder: '',
      hohlschnitt: ''
    }
    state.materialColorCode = ''
    state.colorSelected = undefined
    state.materialTabIndex = 0
    state.materialSelected = 1
  }
}

const actions = {
  setMaterialType: ({ commit }, material) => {
    commit('SET_MATERIAL_TYPE', material)
  },
  setMaterialColor: ({ commit }, matColor) => {
    commit('SET_MATERIAL_COLOR', matColor)
  },
  setMaterialTabIndex: ({ commit }, value) => {
    commit('SET_MATERIAL_TABINDEX', value)
  },
  clearMaterialColor: ({ commit }) => {
    commit('CLEAR_MATERIAL_COLOR')
  },
  selectMaterial: ({ commit }, index) => {
    commit('SELECT_MATERIAL', index)
  },
  selectColor: ({ commit }, index) => {
    commit('SELECT_COLOR', index)
  },
  clearMaterial: ({ commit }) => {
    commit('CLEAR_MATERIAL')
  }
}

const getters = {
  materialType: state => {
    return state.materialType
  },
  materialTypeCode: state => {
    return state.materialTypeCode
  },
  materialColor: state => {
    return state.materialColor
  },
  materialColorImg: state => {
    return state.materialColorImg
  },
  materialColorCode: state => {
    return state.materialColorCode
  },
  materialTabIndex: state => {
    return state.materialTabIndex
  },
  materialSelected: state => {
    return state.materialSelected
  },
  colorSelected: state => {
    return state.colorSelected
  },
  activeHohlschnittMaterial: state => {
    return (state.materialType === Data.materials.pvc360.type) || (state.materialType === Data.materials.pvc690b1.type) || (state.materialType === Data.materials.pvc680.type)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
